module.exports = __webpack_public_path__ + "static/media/speakers_logos_JardineSchindler.f54ad6fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_JardineSchindler.jpg
// module id = 277
// module chunks = 0